import Vue from 'vue'

export default class Message {
  constructor(eventMap) {
    if (!eventMap) {
      throw new Error('`eventMap` is required for intialize message instance!')
    }
    this.on = this.on.bind(this)
    this.once = this.once.bind(this)
    this.emit = this.emit.bind(this)
    this.off = this.off.bind(this)
    this.__isTypeExit = this.__isTypeExit.bind(this)

    this.eventMap = eventMap
    this.__eventBus = new Vue()
  }

  __isTypeExit(type) {
    return Object.values(this.eventMap).includes(type)
  }

  on(type, cb) {
    if (!this.__isTypeExit(type)) {
      throw new Error('unknown message type!')
    } else {
      this.__eventBus.$on(type, cb)
    }
  }

  once(type, cb) {
    if (!this.__isTypeExit(type)) {
      throw new Error('unknown message type!')
    } else {
      this.__eventBus.$once(type, cb)
    }
  }

  emit(type, ...params) {
    if (!this.__isTypeExit(type)) {
      throw new Error('unknown message type!')
    } else {
      this.__eventBus.$emit(type, ...params)
    }
  }

  off(type, cb = null, all = false) {
    if (all) {
      this.__eventBus.$off()
    }
    if (!this.__isTypeExit(type)) {
      throw new Error('unknown message type!')
    } else {
      this.__eventBus.$off(type, cb)
    }
  }
}
